export default __webpack_public_path__ + "static/media/aman-black.d10a20c0.svg";